import React from 'react';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import Spacer from '../spacer';
import Text from '../text';
import Button from '../button';
import Colors from '../colors';
import DividerLine from '../divider-line';
import Status from '../status';
import BreakdownRow from '../breakdown-row';
const StyledContainer = styled.View`
  padding: 12px 16px 24px;
  background: ${Colors.white};
  border: 1px solid;
  border-color: ${Colors.lightGray300}
  box-sizing: border-box;
  border-radius: 4px;
`;
export default function Breakdown(props) {
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Status"
  }, /*#__PURE__*/React.createElement(Status, {
    type: props.status
  }, props.status)), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Amount Advanced",
    amount: props.amount
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Total Fees",
    amount: props.fees
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Total Penalties",
    amount: props.penalties
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    label: "Payment Terms"
  }, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray400
  }, props.terms, ' ', "Terms")), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "total",
    label: "Total Amount Due",
    amount: props.total
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    height: true
  }), /*#__PURE__*/React.createElement(DividerLine, {
    theme: "light"
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    height: true
  }), /*#__PURE__*/React.createElement(BreakdownRow, {
    type: "default",
    label: "Signed Contract"
  }, /*#__PURE__*/React.createElement(Button.Text, {
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    weight: "medium",
    textDecorationLine: "underline"
  }, "View Contract"))));
}
Breakdown.defaultProps = {
  status: 'success',
  amount: 'P0.00',
  fees: 'P0.00',
  penalties: 'P0.00',
  terms: 4,
  total: 'P0.00',
  onPress: () => {}
};
Breakdown.propTypes = {
  status: PropTypes.oneOf(['information', 'error', 'warning', 'success', 'none']),
  amount: PropTypes.string,
  fees: PropTypes.string,
  penalties: PropTypes.string,
  terms: PropTypes.number,
  total: PropTypes.string,
  onPress: PropTypes.func
};
//# sourceMappingURL=breakdown.js.map